import { useEffect, useState } from 'react';

/**
 * Hook that returns true if there is a click outside of the passed ref.
 * @param ref - The reference of the object.
 * @param resetValue - Allows to reset clickedOutside value when is set to true.
 */

export default function useClickOutsideAlerter(ref: React.MutableRefObject<any>, resetValue?: boolean) {
  const [clickedOutside, setClickedOutside] = useState(false);

  useEffect(() => {
    function handleClickOutside(event) {
      if (ref.current && !ref.current.contains(event.target)) {
        setClickedOutside(true);
      }
    }
    // Bind the event listener
    window.addEventListener('click', handleClickOutside, { capture: true });
    return () => {
      // Unbind the event listener on clean up
      window.removeEventListener('click', handleClickOutside, { capture: true });
    };
  }, [ref]);

  useEffect(() => {
    setClickedOutside(false);
  }, [resetValue]);

  return clickedOutside;
}
